<template>
  <div v-if="callBackObj" class="report-list-wrapper">
    <div class="banner">
      <img src="@/assets/image/banner2.png" />
    </div>
    <div class="center-box">
      <ul v-if="callBackObj.data.length">
        <li
          v-for="(item, index) in callBackObj.data"
          @click="onSkipReportFn(item)"
          :key="index"
        >
          <div class="top-box">
            <div class="left">
              <img :src="item.user_info.avatar" />
              <span>{{ item.user_info.nickname }}</span>
            </div>
            <div class="right">
              <span>查看报告</span>
              <img src="@/assets/image/more-icon.png" />
            </div>
          </div>
          <div class="bottom-box">
            <div class="left">
              <div class="title">{{ item.info.title }}</div>
              <div v-if="item.time_consuming" class="date">面试时长：{{ convertSecondsToHMS(item.time_consuming) }}</div>
              <div class="date">{{ item.create_time }}</div>
            </div>
            <div class="right">
              <img :src="item.info.cover" />
              <div class="right-fixed">
                <div v-if="item.is_counting === 1" class="num">评分中...</div>
                <div v-if="item.is_counting === 0" class="num">
                  {{ item.total_score }}
                </div>
                <span v-if="item.is_counting === 0">分</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="callBackObj.data.length === 0" class="no-data">
        暂无面试记录
      </div>
    </div>
    <!--分页码-->
    <div class="pagination-container">
      <el-pagination
        v-if="callBackObj.data.length"
        :current-page="callBackObj.current_page"
        :total="callBackObj.total"
        :page-size="12"
        background
        @current-change="handleCurrentChange"
      />
    </div>
    <!--返回按钮-->
    <div @click="onSkipPageFn('/trainingInterview/welcome')" class="return-btn">
      <img src="@/assets/image/return-icon.png" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

let timer = null

export default {
  data() {
    return {
      channel: '', // 机器ID-渠道ID
      callBackObj: null,
      submitObj: {
        page_size: 12,
        page: 1
      }
    }
  },
  created() {
    this.channel = localStorage.getItem('channel')
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel
      localStorage.setItem('channel', this.channel)
      this.setChannel(this.channel)
    } else if (this.channel) {
      this.setChannel(this.channel)
    } else {
      this.$message({
        message: '参数错误',
        type: 'error'
      })
      return false
    }
    this.getReportListFn()
  },
  methods: {
    ...mapMutations({
      setChannel: 'SET_CHANNEL'
    }),
    ...mapActions(['getReportList']),
    // 获取面试列表
    async getReportListFn() {
      clearInterval(timer)
      this.submitObj['channel'] = this.channel
      this.callBackObj = await this.getReportList(this.submitObj)
      timer = setInterval(() => {
        // this.getReportListFn()
      }, 2000)
    },
    // 跳转报告页面
    onSkipReportFn(item) {
      if (item.is_counting === 1) return false
      this.$router.push({
        query: {
          id: item.id
        },
        path: '/interview/pc_report'
      })
    },
    // 页码跳转
    handleCurrentChange(page) {
      this.submitObj.page = page
      this.getReportListFn()
    },
    // 秒转时分秒
    convertSecondsToHMS(seconds) {
      // const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = seconds % 60
      return minutes + '分钟' + remainingSeconds + '秒'
    },
    // 跳转页面
    onSkipPageFn(url) {
      if (this.channel) {
        this.$router.push(`${url}?channel=${this.channel}`)
      } else {
        this.$router.push(`${url}`)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.report-list-wrapper
  width 100%
  height auto
  .banner
    width 100%
    height auto
    img
      display block
      width 100%
      height auto
  .center-box
    position relative
    width 1544px
    height auto
    padding-top 30px
    margin auto
    ul
      width 100%
      height auto
      display flex
      flex-wrap wrap
      li
        width 368px
        height auto
        margin 0 24px 24px 0
        border-radius 13px
        transition all 0.2s
        cursor pointer
        box-shadow 0 6px 10px 0 rgba(95, 101, 105, 0.15)
        background #fff
        .top-box
          width 100%
          height auto
          padding 13px 17px 12px 20px
          border-bottom 1px solid #ECEAE6
          display flex
          justify-content space-between
          align-items center
          box-sizing border-box
          .left
            display flex
            align-items center
            img
              display block
              width 28px
              height 28px
              border-radius 50%
              overflow hidden
            span
              padding-left 8px
              font-size 14px
              color #34271D
          .right
            display flex
            align-items center
            span
              padding-right 5px
              font-size 14px
              color #34271D
            img
              display block
              width 14px
              height 14px
        .bottom-box
          width 100%
          height auto
          padding 20px
          display flex
          align-items center
          box-sizing border-box
          .left
            flex 1
            height auto
            .title
              font-size 18px
              line-height 18px
              font-weight 500
              color #34271D
            .date
              padding-top 18px
              font-size 14px
              line-height 14px
              color #7B756F
          .right
            position relative
            width 166px
            height 100px
            border-radius 8px
            overflow hidden
            img
              width 100%
              height 100%
              object-fit cover
            .right-fixed
              position absolute
              left 0
              top 0
              width 100%
              height 100%
              z-index 10
              border-radius 8px
              overflow hidden
              display flex
              justify-content center
              align-items center
              background-color rgba(0, 0, 0, 0.7)
              .num
                font-size 24px
                line-height 24px
                font-weight bold
                color #FFDD38
              span
                padding-right 2px
                font-size 14px
                color #FFDD38
      li:hover
        transform translateY(-2px)
        box-shadow 0 6px 10px 0 rgba(95, 101, 105, 0.15)
      li:nth-child(4n)
        margin-right 0
    .no-data
      width 100%
      height auto
      padding-top 10px
      text-align center
      font-size 24px
  .pagination-container
    width 100%
    display flex
    justify-content center
  .return-btn
    position fixed
    left 3%
    top 50%
    width 50px
    height 50px
    cursor pointer
    img
      width 100%
      height 100%
</style>
